interface InfoData {
    summary: string;
    description: string;
    funFact: string;
    url: string;
}

export type MetricItem = {
    value: number;
    label: string;
};

export interface ModuleData {
    label: string;
    color: string;
    isDisabled: boolean;
    title: string;
    metrics: Record<string, MetricItem>;
    info: InfoData;
}

export interface ProviderData {
    name: string;
    displayName: string;
    active: boolean;
}

export interface IntegrationData {
    category: string;
    providers: Record<string, ProviderData>;
    addUrl: string;
}

export enum IntegrationType {
    onPrem = 'onPrem',
    idp = 'Idp',
    iaas = 'Cloud',
    saas = 'Saas'
}

export type IntegrationsDataList = Partial<Record<IntegrationType, IntegrationData>>;

export enum ModuleType {
    identityInventory = 'identityInventory',
    itdr = 'itdr',
    ispm = 'ispm',
    nhiVisibility = 'nhiVisibility', // nhi?
    authenticationFirewall = 'authenticationFirewall',
    privilegedAccessSecurity = 'privilegedAccessSecurity',
    mfaUsers = 'mfaUsers',
    accessAnalysis = 'accessAnalysis'
}
